<filter-table
  [title]="title"
  [data]="propertyLeasesData()"
  [relatedToType]="relatedToType"
  [savedView]="savedView()"
  [queryFilters]="queryFilters"
  [fieldDefs]="fieldDefs()"
  [displayColumns]="displayColumns()"
  [dataset]="dataset()"
  [pagination]="pagination()"
  [sortState]="sortState()"
  [addNewObjectConfig]="addNewObjectConfig"
  [tableIsLoading]="isLoading()"
  (pageEvent)="page($event)"
  (sortEvent)="sort($event)"
  (filterEvent)="filter($event)"
  (searchEvent)="search($event)"
  (updateEvent)="update($event)"
  (addNewObjectEvent)="onNewObjectAdded()"
></filter-table>
